import { Controller } from "stimulus"

import ahoy from 'ahoy.js'

// Connects to data-controller="ahoy--events"
export default class extends Controller {
  static targets = ["launch", "submit"]

  logEvent() {
    let descriptor
    let properties = {}

    if (this.hasSubmitTarget) {
      descriptor = this.submitTarget.dataset.eventDescriptor
    } else {
      properties["device"] = this.launchTarget.dataset.device
      descriptor = this.launchTarget.dataset.eventDescriptor
    }


    ahoy.track(descriptor, properties);
  }
}
